import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { memo } from 'react';

type ResultsPagingStatusProps = {
    readonly formatNumber: Function;
    readonly page: number;
    readonly pageSize: number;
    testid?: string;
    readonly totalRecords: number;
};

export const makeNumbers = (page: number, pageSize: number, totalRecords: number) => {
    const firstNumber = page === 1 ? 1 : pageSize * (page - 1) + 1;
    const secondNumber = totalRecords < pageSize ? totalRecords : pageSize * page;
    return {
        firstNumber,
        secondNumber: secondNumber > totalRecords ? totalRecords : secondNumber,
    };
};

const ResultsPagingStatusComponent = ({
    formatNumber = (num: number) => num,
    page,
    pageSize,
    testid = 'messengerResultsPagingStatus',
    totalRecords,
}: ResultsPagingStatusProps) => {
    const { firstNumber, secondNumber } = makeNumbers(page, pageSize, totalRecords);
    if (!firstNumber || !secondNumber || !totalRecords) {
        return null;
    }
    const text =
        firstNumber === secondNumber
            ? `${formatNumber(firstNumber)} of ${formatNumber(totalRecords)}`
            : `${formatNumber(firstNumber)}-${formatNumber(secondNumber)} of ${formatNumber(totalRecords)}`;
    return (
        <div
            className="lowercase"
            data-testid={testid}
        >
            <BodySecondary color="secondary">{text}</BodySecondary>
        </div>
    );
};

export const ResultsPagingStatus = memo<ResultsPagingStatusProps>(ResultsPagingStatusComponent);
